module.exports = __webpack_public_path__ + "static/media/mcc-fees.8280d0b1.svg";